import React from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";
import { GroupHeaderProps } from "../types";

/**
 * Group header component - collapsible header for grouped items
 */
export function GroupHeader({
  groupLabel,
  itemCount,
  isExpanded,
  isPrimary,
  isSecondary,
  onToggle,
  renderGroupHeader,
}: GroupHeaderProps) {
  return (
    <button type="button"
      onClick={onToggle}
      className={cn(
        "w-full flex items-center gap-3 px-4 py-3 hover:opacity-80 transition-opacity",
        isPrimary && "hover:bg-card-100",
        isSecondary && "hover:bg-blue-100 dark:hover:bg-blue-900/40"
      )}
    >
      <ChevronDown
        className={cn(
          "h-5 w-5 transition-transform flex-shrink-0",
          !isExpanded && "-rotate-90"
        )}
      />
      {renderGroupHeader ? (
        renderGroupHeader(groupLabel, itemCount, isExpanded)
      ) : (
        <>
          <span className={cn("font-semibold", isPrimary ? "text-base" : "text-sm")}>
            {groupLabel}
          </span>
          <span
            className={cn(
              "text-xs px-2 py-1 rounded-full",
              isPrimary ? "bg-card-200" : "bg-blue-200 dark:bg-blue-900/50"
            )}
          >
            {itemCount}
          </span>
        </>
      )}
    </button>
  );
}

// Made with Bob
